import { useMemo } from "react";
import L from "../../../constants/baysportLabels";
import { Field, Select } from "../../ui";
import aa from "../AdminPortal/adminApp.module.css";

function groupOptionLabel(g) {
  const dir = g.direction?.name || g.sport_direction;
  return dir ? `${g.name} · ${dir}` : g.name;
}

export default function CompetitionAudienceFields({
  form,
  onChange,
  groups = [],
  directions = [],
  className = "",
}) {
  const directionId = form.competition_direction_id || "";

  const filteredGroups = useMemo(() => {
    if (!directionId) return groups;
    return groups.filter(
      (g) =>
        String(g.direction_id || g.direction?.id || "") === String(directionId),
    );
  }, [groups, directionId]);

  return (
    <div className={className || aa.calCreateSection}>
      <p className={aa.calCreateSectionTitle}>Для кого</p>
      {directions.length > 0 ? (
        <Field label={L.direction} hint="Сузить список групп">
          <Select
            value={directionId}
            onChange={(e) => {
              const nextDir = e.target.value;
              const nextGroups = nextDir
                ? groups.filter(
                    (g) =>
                      String(g.direction_id || g.direction?.id || "") ===
                      String(nextDir),
                  )
                : groups;
              const specOk = nextGroups.some(
                (g) => String(g.id) === String(form.specialization_id),
              );
              onChange({
                competition_direction_id: nextDir,
                ...(form.specialization_id && !specOk
                  ? { specialization_id: "" }
                  : {}),
              });
            }}
          >
            <option value="">Все {L.directions.toLowerCase()}</option>
            {directions.map((d) => (
              <option key={d.id} value={d.id}>
                {d.name}
              </option>
            ))}
          </Select>
        </Field>
      ) : null}
      <Field label={L.group} hint="Пусто — соревнование для всего клуба">
        <Select
          value={form.specialization_id || ""}
          onChange={(e) =>
            onChange({ specialization_id: e.target.value || "" })
          }
        >
          <option value="">Весь клуб</option>
          {filteredGroups.map((g) => (
            <option key={g.id} value={g.id}>
              {groupOptionLabel(g)}
            </option>
          ))}
        </Select>
      </Field>
    </div>
  );
}
